"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsDataProvider = exports.useEventsDataContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const lodash_1 = __importDefault(require("lodash"));
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const use_custom_compare_1 = require("use-custom-compare");
const EventApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventApiService");
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const DashboardApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/DashboardApiService");
const EventsDataContext = React.createContext({});
const useEventsDataContext = () => React.useContext(EventsDataContext);
exports.useEventsDataContext = useEventsDataContext;
const EventsDataProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const projectApiKey = currentProjectContext === null || currentProjectContext === void 0 ? void 0 : currentProjectContext.projectApiKey;
    const [eventNamesState, setEventNamesState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep(DataProviderCommonTypes_1.initialDataProviderCommonState));
    const fetchEventNames = (0, react_1.useCallback)(async () => {
        const get = async () => {
            setEventNamesState({ inProgress: true });
            try {
                if (process.env.NODE_ENV === "development") {
                    console.log("EventsDataProvider: fetchEventNames!");
                    // await delayPromise(2000)
                    //     if (Math.random() < 0.8) {
                    //         throw new Error("aaaa")
                    //     }
                }
                const actorResult = await projectsContext.getActor(projectApiKey);
                if (!lodash_1.default.isNil(actorResult.error)) {
                    console.warn("fetchEventNames failed", actorResult.error);
                    setEventNamesState({
                        inProgress: false,
                        error: actorResult.error,
                        isError: true,
                    });
                }
                else {
                    const eventNamesResult = await (0, EventApiService_1.getProjectEventNamesResult)(actorResult.actors, actorResult.accessToken);
                    const result = (0, DataProviderCommonTypes_1.getDataProviderCommonStateFromICResult)(eventNamesResult);
                    setEventNamesState({
                        ...result,
                        data: lodash_1.default.sortBy(result.data, v => lodash_1.default.lowerCase(v))
                    });
                }
            }
            catch (e) {
                console.warn("EventsDataProvider: fetchEventNames failed", e);
                setEventNamesState({
                    loaded: true,
                    inProgress: false,
                    error: e,
                    isError: true,
                });
            }
        };
        // noinspection ES6MissingAwait
        get();
    }, [isMounted, projectApiKey]);
    const fetchEventUniques = (0, react_1.useCallback)(async (queryEventVariants, lastNDays, aggregation) => {
        try {
            if (process.env.NODE_ENV === "development") {
                console.log("EventsDataProvider: fetchEventUniques!", { queryEventVariants, lastNDays, aggregation });
                //     await delayPromise(1000)
                //     if (Math.random() < 0.8) {
                //         throw new Error("aaaa")
                //     }
            }
            const actorResult = await projectsContext.getActor(projectApiKey);
            if (!lodash_1.default.isNil(actorResult.error)) {
                console.warn("EventsDataProvider: fetchEventUniques failed. no actor", actorResult.error);
                // noinspection ExceptionCaughtLocallyJS
                throw actorResult.error;
            }
            else {
                const promises = [
                    (0, DashboardApiService_1.getProjectDashboardResultByChunks)(actorResult.actors, actorResult.accessToken, lastNDays),
                    (0, EventApiService_1.getProjectEventsUniquesByAggregation)(actorResult.actors, actorResult.accessToken, queryEventVariants, lastNDays, aggregation)
                ];
                const promiseAllSettledResult = await Promise.allSettled(promises);
                const projectDashboardFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromSettledPromiseResult)(promiseAllSettledResult[0]);
                const projectDashboardResultUsersResult = (0, ProjectDashboardDataProvider_1.calculateActiveUsersFeatureState)(projectDashboardFeatureState);
                const projectDashboardEventsFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromSettledPromiseResult)(promiseAllSettledResult[1]);
                if (!projectDashboardResultUsersResult.isError && !projectDashboardEventsFeatureState.isError) {
                    if (projectDashboardEventsFeatureState.state && projectDashboardResultUsersResult.state) {
                        return {
                            uniques: projectDashboardEventsFeatureState.state.uniques,
                            dau: projectDashboardResultUsersResult.state.dau,
                            wau: projectDashboardResultUsersResult.state.wau,
                            mau: projectDashboardResultUsersResult.state.mau,
                        };
                    }
                }
                if (projectDashboardResultUsersResult.error) {
                    // noinspection ExceptionCaughtLocallyJS
                    throw projectDashboardResultUsersResult.error;
                }
                if (projectDashboardEventsFeatureState.error) {
                    // noinspection ExceptionCaughtLocallyJS
                    throw projectDashboardEventsFeatureState.error;
                }
                // noinspection ExceptionCaughtLocallyJS
                throw new Error("unknown");
            }
        }
        catch (e) {
            throw e;
        }
        // noinspection ExceptionCaughtLocallyJS
        throw new Error("unknown");
    }, [isMounted, projectApiKey]);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        eventNamesState,
        fetchEventNames,
        fetchEventUniques,
    }), [
        eventNamesState,
        fetchEventNames,
        fetchEventUniques,
    ], lodash_1.default.isEqual);
    return React.createElement(EventsDataContext.Provider, { value: value }, props.children);
};
exports.EventsDataProvider = EventsDataProvider;
